<template>
    <div class="header">
        <span class="system-name">HyperSpace 运营管理系统</span>
        <ul class="user-menu">
            <li>
                <span class="storename">{{ storeName }}</span>
                <el-dropdown trigger="click" @command="handleCommand">
                    <el-avatar :size="40" :src="userAvatar" style="vertical-align: middle;"></el-avatar>
                    <el-dropdown-menu slot="dropdown" >
                        <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            storeName: '',
            userAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
        }
    },
    mounted() {
        this.storeName = this.$store.getters.getStoreName || "";
        this.$bus.$on('getStoreName',(val) => {
            this.storeName = val
        })
    },
    methods: {
        loginOut() {
            localStorage.clear();
            this.$router.replace('/');
        },
        handleCommand(command) {
            this[command]();
        }
    }
}
</script>

<style lang="scss" scoped>
.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    background: #fff;
    padding: 0 20px;
    box-sizing: border-box;
    .storename{
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
    }
    .system-name{
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 1px;
        color: var(--themeColor);
    }
    .user-menu {
        float: right;
        margin: 0;
        position: relative;
        z-index: 99;
        height: 60px;
    }
    .el-dropdown{
        height: 60px;
        padding: 10px;
        box-sizing: border-box;
        cursor: pointer;
    }
}
</style>